import Vue from "vue";
import VueRouter from "vue-router";
import routes from '@/router/routes';
import store from '@/store'

Vue.use(VueRouter);

const scrollBehavior = (to, from, savedPosition) => {
  return {
    x: 0,
    y: 0
  }
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    el => {
      if (el.parentNode) return el.parentNode.removeChild(el);
    }
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

// Resets for Insights`s layout
router.beforeEach((to, from, next) => {
  if (to.name === 'platform') {
    store.commit('base/SET_PLATFORM_ACTIONS', [])
    store.commit('base/SET_PLATFORM_ATTRIBUTES', [])

    store.dispatch('base/resetPageFilter')
  }

  next()
})

// Link from Argus
router.beforeEach((to, from, next) => {
  const { path, query } = to
  const isLeadPath = path === '/lead'
  const hasQueryCleverId = Object.keys(query).some(item => /^cleverid$/i.test(item))

  if (isLeadPath && hasQueryCleverId) {
    next({
      path: '/leads',
      query
    })
  } else {
    next()
  }
})

export default router;
